import { useEffect, useState } from 'react';
import apiClient from '../../services/apiClientService';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useTenant } from '../../contexts/TenantContext';

// The supplies `providerId` offers; without one, every supply of the tenant, as for „Bárki”.
export const fetchSupplies = async (tenantId, providerId) => {
  const response = await apiClient.get(`/v1/public/tenants/${tenantId}/supplies`, {
    params: { providerId },
  });
  return response.data;
};

const useGetSupplies = (providerId) => {
  const { tenantId } = useTenant();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const getSupplies = async () => {
    setLoading(true);

    try {
      setData(await fetchSupplies(tenantId, providerId));
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSupplies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerId]);

  return { data, loading };
};

export default useGetSupplies;
